import { Helmet } from "react-helmet-async";
import CoinBadge from "./CoinBadge";
import Logo from "./Logo";
import { cn } from "../../../Utils/helper";

const Header = ({ backgroundHeader }) => {
  return (
    <header className={cn("section-header", backgroundHeader)}>
      <Helmet>
        <meta name="theme-color" content="#FFFFFF" />
      </Helmet>
      <Logo />
      <CoinBadge />
    </header>
  );
};

export default Header;
